import React, {Component} from 'react';
import {gpn} from "../GPN"
import Button from "../sections/MUI/Button";
import axios from "axios";
import config from "../config";
import Field from "../sections/MUI/Field";
import {toast} from "react-toastify";
import Icon from "../sections/MUI/Icon";
import Modal from "../sections/MUI/Modal";

class Regions extends Component {

    state = {
        regions: [],
        boxAdd: false,

        title: "",
        price: "",

        editIndex: -1
    };

    componentDidMount() {
        config.scrollTop();
        this.getRegions();
    }


    getRegions() {
        axios.get(`${config.api}/admin/region?token=${config.token}`)
            .then(r => {
                this.setState({regions: r.data.result});
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    submit() {
        const {title, price} = this.state;
        if (title !== "" && price !== "") {
            let params = new URLSearchParams();
            params.append("title", title);
            params.append("price", price.toString().replace(/,/g, "").toString().trim());
            toast.info("در حال ثبت ...")
            axios.post(`${config.api}/admin/region?token=${config.token}`, params)
                .then(r => {
                    toast.success("با موفقیت ثبت شد");
                    this.getRegions();
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("فیلد ها را تکمیل کنید.")
        }
    }

    handleInputChange(name, value) {
        let {regions, editIndex} = this.state;
        regions[editIndex][name] = value;
        this.setState({regions});
    }

    edit() {
        const {editIndex, regions} = this.state;

        const {id, title, price} = regions[editIndex];

        if (title !== "" && price.toString() !== "") {
            let params = new URLSearchParams();
            params.append("id", id);
            params.append("title", title);
            params.append("price", price.toString().replace(/,/g, "").toString().trim());
            toast.info("در حال ویرایش ...")
            axios.put(`${config.api}/admin/region?token=${config.token}`, params)
                .then(r => {
                    toast.success("با موفقیت ویرایش شد!");
                    this.getRegions();
                    this.setState({editIndex: -1});
                })
                .catch(err => {
                    config.handleError(err)
                });
        } else {
            toast.error("همه فیلد ها را به درستی وارد کنید.")
        }
    }

    delete(id) {
        toast.info("در حال حذف ...")
        axios.delete(`${config.api}/admin/region?token=${config.token}&id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد.");
                this.getRegions();
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    render() {
        const {regions, title, price, boxAdd, editIndex} = this.state;
        return (
            <div className="regions">

                {editIndex !== -1 ?
                    <Modal display={editIndex !== -1}
                           onCloseClick={() => this.setState({editIndex: -1})}>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <Field name="title"
                                       label="نام محله"
                                       maxLength={200}
                                       value={regions[editIndex].title}
                                       onChange={(name, value) => this.handleInputChange(name, value)}/>
                            </div>
                            <div className="col-md-6">
                                <Field name="price"
                                       label="هزینه ایاب و ذهاب"
                                       maxLength={200}
                                       typePrice
                                       style={{direction: "ltr"}}
                                       value={regions[editIndex].price.toString()}
                                       onChange={(name, value) => this.handleInputChange(name, value)}/>

                            </div>
                            <div className="col-md-6">
                                <Button submit={false} icon="edit"
                                        onClick={() => this.edit()}>ویرایش</Button>
                            </div>
                        </div>
                    </Modal>
                    : null
                }
                <div className="row">
                    <div className="col-md-5">
                        <Button submit={false} icon="plus" onClick={() => this.setState({boxAdd: !boxAdd})}>ثبت
                            کردن</Button>
                    </div>
                </div>

                {
                    boxAdd ?
                        <div className="new">
                            <div className="row">
                                <div className="col-md-4">
                                    <Field name="title"
                                           value={title}
                                           label="نام محله"
                                           maxLength={200}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-md-4">
                                    <Field name="price"
                                           value={price}
                                           typePrice
                                           style={{direction: "ltr"}}
                                           label="هزینه ایاب و ذهاب"
                                           maxLength={200}
                                           onChange={(name, value) => this.setState({[name]: value})}/>

                                </div>
                                <div className="col-md-4">
                                    <Button submit={false} icon="plus" onClick={() => this.submit()}>ثبت کردن</Button>
                                </div>
                            </div>
                        </div>
                        : null
                }

                <br/>
                <div className="list">
                    {
                        regions.map((r, i) =>
                            <article key={"reg" + i}>
                                <div className="row">
                                    <div className="col-auto">
                                        <p className="title">{r.title}</p>
                                    </div>
                                    <div className="col">
                                        <p className="price">{config.priceFormatter(r.price)}</p>
                                    </div>
                                    <div className="col-auto">
                                        <Icon i="edit" className="edit-icon"
                                              onClick={() => this.setState({editIndex: i})}/>
                                        <Icon i="trash" className="delete-icon"
                                              onDoubleClick={() => this.delete(r.id)}/>
                                    </div>
                                </div>
                            </article>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default gpn(Regions);